/**
 *
 * @param {object} obj Object with snake_case keys
 * @returns {object} Object with camelCase keys
 */
const camelCaseKeys = (obj) => {
  return Object.keys(obj).reduce((acc, key) => {
    const camelCaseKey = key.replace(/_([a-z])/g, (g) => g[1].toUpperCase())
    acc[camelCaseKey] = obj[key]
    return acc
  }, {})
}

export { camelCaseKeys }
